import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[dynamicTitle]'
})
export class DynamicTitleDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.setElementTitle();
    this.el.nativeElement.addEventListener('mouseover', () => {
      this.setElementTitle();
    })
  }

  setElementTitle(){
    const textContent = this.el.nativeElement.textContent.trim();
    this.renderer.setAttribute(this.el.nativeElement, 'title', textContent);
  }

}
